export default __webpack_public_path__ + "static/media/13.ece5c369.mp3";